import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatepickerService } from '../service/datepicker.service';

@Component({
  selector: 'app-month',
  templateUrl: './month.component.html',
  styleUrls: ['./month.component.css', '../date-time-picker.component.css']
})
export class MonthComponent implements OnInit {


  @Input() field:any;
  @Output() toggle = new EventEmitter();

  constructor(public datepicker_serv:DatepickerService) { }
  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  selectedMonth!:number;
  currentMonth=new Date().getMonth()

  ngOnInit() {
    this.datepicker_serv.month.subscribe(
      (x)=>{
        this.selectedMonth=x
      }
    )

  }
  changeMonth(i:number){
    this.datepicker_serv.changeMonth(i)
    this.toggle.emit();
  }


}
